import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthenticationService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PatientService {

  base_uri;
  constructor(
    private http: HttpClient,
    private authService: AuthenticationService
    ) { 
    this.base_uri = environment.patient_uri;
  }

  authenticatePatient(data) {
    let url = this.base_uri + "patient/authenticate";
    return this.http.post(url, data, {});
  }
  getFeedbacks(data) {
    let url = this.base_uri + "patient/feedback/get";
    return this.http.post(url,data,{
      headers: new HttpHeaders().set(
        "Authorization",
        "Bearer " + this.authService.getToken()
      )
    })
  }
  createFeedbacks(data) {
    let url = this.base_uri + "patient/feedback/create";
    return this.http.post(url,data,{
      headers: new HttpHeaders().set(
        "Authorization",
        "Bearer " + this.authService.getToken()
      )
    })
  }
  createPreRegisteration(data) {
    let url = this.base_uri + "patient/preregister/create";
    return this.http.post(url,data,{
      headers: new HttpHeaders().set(
        "Authorization",
        "Bearer " + this.authService.getToken()
      )
    });
  }
}
